module.exports = __webpack_public_path__ + "img/background_gradient.9e3775eb.png";